import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import '../../css/loans.css';
import user from '../../js/stores/user.js';
import language from '../../js/stores/language.js';
import RequestTab from './components/request-tab.f7.html';
import DecidingTab from './components/deciding-tab.f7.html';
import PaymentTab from './components/payment-tab.f7.html';
import AppointmentTab from './components/appointment-tab.f7.html';
import MeetingTab from './components/meeting-tab.f7.html';
import StoppingTab from './components/stopping-tab.f7.html';
import IssueTab from './components/issue-tab.f7.html';
import RatingTab from './components/rating-tab.f7.html';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $f7route = _ref.$f7route,
    $f7router = _ref.$f7router;
  var locale = language.getters.Item.value;
  var totalToPay = 0.00;
  var isOwner = user.getters.carId.value == props.CarMainData.CarId ? true : false;
  var isBorrower = user.getters.carId.value != props.CarMainData.CarId ? true : false;
  var configMeetingData = {
    4: {
      currentLoanStatusId: 4,
      tabId: 'tab-5-meeting',
      filesEvents: ['getLoanCarImages', 'getLoanDriverImages'],
      loanCarTag: 'loan-car',
      loanDriverTag: 'loan-driver',
      uploadLoadCarImagesEvent: 'uploadLoanCarImages',
      uploadLoadDriverImagesEvent: 'uploadLoanDriverImages',
      saveEvent: 'saveLoanEventStart',
      currentFuelLevel: props.CarLoanData.CarLoanStatusId > 4 ? props.CarLoanData.CurrentFuelLevel : 0,
      currentKilometers: props.CarLoanData.CarLoanStatusId > 4 ? props.CarLoanData.CurrentKilometers : 0,
      prefix: 'current',
      upperSuffix: 'Current',
      confirmMessage: 'confirmStartLoan'
    },
    6: {
      currentLoanStatusId: 6,
      tabId: 'tab-7-returning',
      filesEvents: ['getReturnLoanCarImages', 'getReturnLoanDriverImages'],
      loanCarTag: 'return-car',
      loanDriverTag: 'return-driver',
      uploadLoadCarImagesEvent: 'uploadLoanReturnCarImages',
      uploadLoadDriverImagesEvent: 'uploadLoanReturnDriverImages',
      saveEvent: 'saveLoanEventEnd',
      currentFuelLevel: props.CarLoanData.CarLoanStatusId > 6 ? props.CarLoanData.ReturningFuelLevel : 0,
      currentKilometers: props.CarLoanData.CarLoanStatusId > 6 ? props.CarLoanData.ReturningKilometers : 0,
      prefix: 'returning',
      upperSuffix: 'Returning',
      confirmMessage: 'confirmEndLoan'
    }
  };
  var invoiceData = {};
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (props.CarLoanData.CarLoanId > 0) {
            totalToPay = props.CarLoanData.TotalToPay;
          }
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var updatePrice = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            totalToPay = value.detail.TotalToPay;
            invoiceData = value.detail;
            $update();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function updatePrice(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="loan-item">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">
        ${locale.translate('loan.title')} ${props.CarLoanData.CarLoanTag}
      </div>
    </div>
  </div>
  ${props.CarLoanData.CarLoanId < 1 && $h`
  <div class="fab fab-extended fab-right-top color-deeporange">
    <a class="button popup-open" href="#" data-popup=".demo-popup">
      <span class="material-symbols-outlined">sell</span>
      <div id="total-cart" class="cart-cst fab-text">€ ${totalToPay}</div>
    </a>
  </div>
  `}
  <div class="toolbar toolbar-top tabbar tabbar-scrollable">
    <div class="toolbar-inner">
      <a href="#tab-1-request" class="tab-link tab-link-active">
        <i class="material-symbols-outlined">quiz</i>
        <span class="hidden-xs-down-text">${locale.translate('loan.tabs[0]')}</span>
      </a>
    ${props.CarLoanData.CarLoanId > 0 && $h`
      ${(props.CarLoanData.CarLoanStatusId == 1 && isOwner) ? $h`
      <a href="#tab-2-deciding" class="tab-link">
        <i class="material-symbols-outlined">handshake</i>
        <span class="hidden-xs-down-text">${locale.translate('loan.tabs[1]')}</span>
      </a>
      ` : $h`<span></span>`}
      ${(props.CarLoanData.CarLoanStatusId == 2 && isBorrower) ? $h`
      <a href="#tab-3-payment" class="tab-link">
        <i class="material-symbols-outlined">payments</i>
        <span class="hidden-xs-down-text">${locale.translate('loan.tabs[2]')}</span>
      </a>
      ` : $h`<span></span>`}
      ${(props.CarLoanData.CarLoanStatusId > 2 && props.CarLoanData.CarLoanStatusId < 11) ? $h`
      <a href="#tab-4-appointment" class="tab-link">
        <i class="material-symbols-outlined">event</i>
        <span class="hidden-xs-down-text">${locale.translate('loan.tabs[3]')}</span>
      </a>
      ` : $h`<span></span>`}
      ${(props.CarLoanData.CarLoanStatusId > 3 && props.CarLoanData.CarLoanStatusId < 11) ? $h`
      <a href="#tab-5-meeting" class="tab-link">
        <i class="material-symbols-outlined">where_to_vote</i>
        <span class="hidden-xs-down-text">${locale.translate('loan.tabs[4]')}</span>
      </a>
      ` : $h`<span></span>`}
      ${(props.CarLoanData.CarLoanStatusId > 4 && props.CarLoanData.CarLoanStatusId < 11) ? $h`
      <a href="#tab-6-stopping" class="tab-link">
        <i class="material-symbols-outlined">free_cancellation</i>
        <span class="hidden-xs-down-text">${locale.translate('loan.tabs[5]')}</span>
      </a>
      ` : $h`<span></span>`}
      ${(props.CarLoanData.CarLoanStatusId > 5 && props.CarLoanData.CarLoanStatusId < 11) ? $h`
      <a href="#tab-7-returning" class="tab-link">
        <i class="material-symbols-outlined">assignment_returned</i>
        <span class="hidden-xs-down-text">${locale.translate('loan.tabs[6]')}</span>
      </a>
      ` : $h`<span></span>`}
      ${(props.CarLoanData.CarLoanStatusId > 6 && props.CarLoanData.CarLoanStatusId < 11) ? $h`
      <a href="#tab-8-rating" class="tab-link">
        <i class="material-symbols-outlined">reviews</i>
        <span class="hidden-xs-down-text">${locale.translate('loan.tabs[7]')}</span>
      </a>
      ` : $h`<span></span>`}
      ${(props.CarLoanData.CarLoanStatusId > 6 && props.CarLoanData.CarLoanStatusId < 11) ? $h`
        <a href="#tab-9-issue" class="tab-link">
          <i class="material-symbols-outlined">taxi_alert</i>
          <span class="hidden-xs-down-text">${locale.translate('loan.tabs[8]')}</span>
        </a>
        ` : $h`<span></span>`}
    `}
    </div>
  </div>
  <div class="tabs center-content">
    <${RequestTab} data=${props} @eventPrice=${updatePrice}/>
    ${props.CarLoanData.CarLoanId > 0 && $h`

    ${(props.CarLoanData.CarLoanStatusId == 1 && isOwner) ? $h`<${DecidingTab} data=${props} />` : $h`<span></span>`}
    ${(props.CarLoanData.CarLoanStatusId == 2 && isBorrower) ? $h`<${PaymentTab} data=${props} />` : $h`<span></span>`}
    ${(props.CarLoanData.CarLoanStatusId > 2 && props.CarLoanData.CarLoanStatusId < 11) ? $h`<${AppointmentTab} data=${props} />` : $h`<span></span>`}

    ${(props.CarLoanData.CarLoanStatusId > 3 && props.CarLoanData.CarLoanStatusId < 11) ? $h`
      <${MeetingTab} data=${props} config=${configMeetingData[4]} />
    ` : $h`
    <span></span>
    `}

    ${(props.CarLoanData.CarLoanStatusId > 4 && props.CarLoanData.CarLoanStatusId < 11) ? $h`<${StoppingTab} data=${props} />` : $h`<span></span>`}

    ${(props.CarLoanData.CarLoanStatusId > 5 && props.CarLoanData.CarLoanStatusId < 11) ? $h`
      <${MeetingTab} data=${props} config=${configMeetingData[6]} />
    ` : $h`
    <span></span>
    `}

    ${(props.CarLoanData.CarLoanStatusId > 6 && props.CarLoanData.CarLoanStatusId < 11) ? $h`<${IssueTab} data=${props} />` : $h`<span></span>`}
    ${(props.CarLoanData.CarLoanStatusId > 6 && props.CarLoanData.CarLoanStatusId < 11) ? $h`<${RatingTab} data=${props} />` : $h`<span></span>`}

    `}
  </div>
  <div class="popup demo-popup">
    <div class="page">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">${locale.translate('loan.request.invoice.title')}</div>
          <div class="right">
            <a class="link popup-close">
              <i class="icon material-symbols-outlined color-blue">cancel</i>
            </a>
          </div>
        </div>
      </div>
      <div class="page-content">
        <div class="block justify-content-center" style="max-width: 340px;margin: auto;">
          <p>${locale.translate('loan.request.invoice.details')}:</p>
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.basePrice', [invoiceData.BasePrice, invoiceData.DaysToBorrow])}: </div> <div class="text-align-right">€${Number(invoiceData.BasePrice*invoiceData.DaysToBorrow)}</div>
          </div>
          ${invoiceData.WeeksToBorrow > 0 ? $h`
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.weeksToBorrow')}: </div> <div class="text-align-right">${invoiceData.WeeksToBorrow}</div>
          </div>
          ` : $h`<div></div>`}
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.serviceFee')}: </div> <div class="text-align-right">€${invoiceData.ServiceFee}</div>
          </div>
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.administrativeFee')}:</div> <div class="text-align-right">€${invoiceData.AdminstrativeFee}</div>
          </div>
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.weekendSurcharge', [invoiceData.WeekendSurchargePercent])}:</div> <div class="text-align-right">€${invoiceData.WeekendSurcharge}</div>
          </div>
          ${invoiceData.DaysToGoAbroad > 0 ? $h`
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.daysToGoAbroad')}:</div> <div class="text-align-right">€${invoiceData.DaysToGoAbroad}</div>
          </div>
          ` : $h`<div></div>`}
          ${invoiceData.HolidaySurcharge > 0 ? $h`
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.holidaySurcharge')}:</div> <div class="text-align-right">€${invoiceData.HolidaySurcharge}</div>
          </div>
          ` : $h`<div></div>`}
          ${invoiceData.Under26Age > 0 ? $h`
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.underAgeRate')}:</div> <div class="text-align-right">€${invoiceData.Under26Age}</div>
          </div>
          ` : $h`<div></div>`}
          ${invoiceData.BuyoutDepositFee > 0 ? $h`
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>Discount in Buyout:</div> <div class="text-align-right">€${Number(250-invoiceData.BuyoutDepositToPay)}</div>
          </div>
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div>${locale.translate('loan.request.invoice.depositFee')}: </div> <div class="text-align-right">€${invoiceData.BuyoutDepositFee}</div>
          </div>
          ` : $h`<div></div>`}
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div class="data">${locale.translate('loan.request.invoice.discountPercent', [invoiceData.Discount])}: </div> <a class="text-align-right color-green discount">- €${invoiceData.TotalDiscount}</a>
          </div>
          ${invoiceData.BuyoutDepositToPay > 0 ? $h`
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div class="data">${locale.translate('loan.request.invoice.depositToPay')}: </div> <div class="text-align-right">€${invoiceData.BuyoutDepositToPay}</div>
          </div>
          ` : $h`<div></div>`}
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div class="data">${locale.translate('loan.request.invoice.subtotal')}:</div> <div class="text-align-right">€${invoiceData.SubTotalToPay}</div>
          </div>
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
            <div class="data">${locale.translate('loan.request.invoice.taxes')}:</div> <div class="text-align-right">€${invoiceData.Taxes}</div>
          </div>
          <div class="grid grid-cols-2">
            <div>-----</div><div class="text-align-right">-----</div>
          </div>
          <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap data">
            <div>${locale.translate('loan.request.invoice.totalToPay')}:</div> <div class="text-align-right">€${invoiceData.TotalToPay}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = 'cfa31d962c';
export default framework7Component;